<!--
{
  "type": "gallery",
  "data": {
    "style": "landscape-thumb-carousel",
    "title": "",
    "description": "",
    "items": [
      {
        "type": "video" | "image",
        "video": {
          "src": "<youtube embed link>>"
        },
        "image": {
          "filestorename": "website",
          "filepath": "/path/to/file",
          "data" {
            "title": "",
            "alt": "",
            "iconratio": "16-10" | "16-9" | "3-2" | "4-3" | "3-4" | "1-1"
          }
        }
      }
      ...
    ]
  }
}
-->
<template>
  <section class="gallery mb-3">
    <b-container>
      <b-row v-if="title">
        <b-col>
          <h3>{{ title }}</h3>
        </b-col>
      </b-row>
      <b-row v-if="description">
        <b-col
          class="description"
          v-html="description"
        />
      </b-row>
      <b-row>
        <b-col>
          <component
            :is="styleComponent"
            :media="media"
          />
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>

import SliceTypeGalleryStyleLandscapeThumbCarousel from './gallery-styles/landscape-thumb-carousel'

export default {
  name: 'slice-type-gallery',
  components: {
    SliceTypeGalleryStyleLandscapeThumbCarousel
  },
  props: {
    slice: {
      type: Object,
      required: false,
      default: function() {
        return {}
      }
    }
  },
  computed: {
    data() {
      return this.slice.data
    },
    title() {
      return this.data.title
    },
    description() {
      return this.data.description
    },
    media() {
      return this.data.items
    },
    styleComponent() {
      return `slice-type-gallery-style-${this.data.style}`
    }
  }
}
</script>

<style lang="scss" scoped>
  h3, .description {
    text-align: center;
  }
</style>
